export const partClassification = {
  'R': 'Repuestos',
  'A': 'Accesorios',
  'G': 'Logística',
  'L': 'Lubricantes',
  'O': 'Otros',
};

export const dayClassification = {
  '1': 'Lunes',
  '2': 'Martes',
  '3': 'Miércoles',
  '4': 'Jueves',
  '5': 'Viernes',
  '6': 'Sábado',
  '7': 'Domingo',
};

export const pickingOrderClassification = {
  '1': 'Quito - Stock',
  '2': 'Quito - Emergente',
  '3': 'Fuera de Quito - Stock',
  '4': 'Fuera de Quito - Emergente',
};

export const storageCarsStatus = {
  '0': 'Por almacenar',
  '1': 'Reservado',
  '2': 'Iniciado proceso almacenamiento',
  'A': 'Almacenado',
  'empty': 'En uso',
};

export const ordersTrackingStatus = {
  'I': 'Iniciado',
  'R': 'Retrasado',
  'A': 'A tiempo',
};

export const dealerOrdersStatus = {
  'entered': 'Ingresado',
  'processed': 'Procesado',
  'inTransit': 'En Tránsito',
  'labeled': 'Etiquetado',
  'billed': 'Facturado',
  'rejected': 'Rechazado',
  'denied': 'Negado',
  'removed': 'Eliminado',
};

export const numbersDictionary = {'1': 'One', '2': 'Two', '3': 'Three', '4': 'Four', '5': 'Five'};

export const transportTypes = [
  {'text': 'Aéreo', 'value': 'A', 'secondValue': 'AEREO'},
  {'text': 'Marítimo', 'value': 'M', 'secondValue': 'MARITIMO'},
  {'text': 'VOR', 'value': 'V', 'secondValue': 'VOR'},
];

export const providerOrderTypes = [
  {'text': 'Normal', 'value': 'NORMAL'},
  {'text': 'INEN', 'value': 'INEN'},
  {'text': 'Manual', 'value': 'MANUAL'},
];

export const providerSequenceTypes = [
  {'text': 'Tipo de pedido', 'value': 'TIPO DE ORDEN'},
  {'text': 'Tipo de transporte', 'value': 'TIPO DE TRANSPORTE'},
  {'text': 'Proveedor', 'value': 'PROVEEDOR'},
];

export const invoicesTypes = [
  {'name': 'Electrónica', 'value': 'ELECTRONICA'},
  {'name': 'Autoimpresa', 'value': 'AUTOIMPRESA'},
];

export const matrixValuesTypes = [{'text': 'Pedidos', 'value': 'orders'}, {'text': 'Ventas', 'value': 'sales'}];

export const dispatchOrderTypes = [
  {'id': 'N', 'description': 'NORMAL'},
  {'id': 'S', 'description': 'ANTICIPADA'},
];
